<template>
  <div class="w-full h-full relative">
    <div ref="panoramaContainer" class="h-full w-full"></div>
    <div class="width-all flex flex-center gap10 padding-tb-md" style="position: absolute;bottom: 50px;left: 0;background-color: rgba(0, 0, 0, 0.3);">
      <div v-for="(item, index) in vrList" :key="index" class="relative cursor-pointer overflow-hidden" style="width: 80px;height: 80px;border-radius: 5px;" @click="checkItem(index)">
        <img :src="vrcover" class="width-all height-all" />
        <div class="absolute left-0 bottom-0 text-white font-xs text-center width-all padding-tb-xs" style="background-color: rgba(0, 0, 0, 0.5);">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Viewer } from 'photo-sphere-viewer';
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
import { getJson } from "@/utils/axios.js"

export default {
  data() {
    return {
      viewer: null, // 全局插件实例
      vrcover: require('@/static/icon/vr_cover.png'),
      vrList: [],
      activeIndex: 0,
      id: this.$route.query.id
    };
  },
  mounted() {
    this.getDetail()
  },
  beforeDestroy() {
    if (this.viewer) {
      this.viewer.destroy()
    }
  },
  methods: {
    getDetail(){
				getJson('/point/detail', {
					id: this.id,
				}, (res) => {
					const { data } = res
            this.vrList = JSON.parse(data.vrinfo)
            this.$nextTick(() => {
              this.initPanoramaViewer()
            })
				})
			},
    checkItem(index){
      if(this.activeIndex === index){
        return
      }
      this.activeIndex = index
      this.viewer.setPanorama(this.vrList[this.activeIndex].cover[0], {
        caption: this.vrList[this.activeIndex].name,
        description: `${this.vrList[this.activeIndex].desc}<br/>${this.vrList[this.activeIndex].address}`,
      });
    },
    initPanoramaViewer() {
      this.viewer = new Viewer({
        container: this.$refs.panoramaContainer, // 挂载容器
        panorama: this.vrList[this.activeIndex].cover[0],
        caption: this.vrList[this.activeIndex].name, // 标题
        description: `${this.vrList[this.activeIndex].desc}<br/>${this.vrList[this.activeIndex].address}`, // 描述
        // loadingImg: 'path/to/your-loading.gif',
        loadingTxt: '拼命加载中...', // 加载中文字
        navbar: [
          "autorotate", // 自动旋转控件
          "zoom", // 放大控件
          "caption", // 标题
          "fullscreen", // 全屏控件
          "description", // 描述
          "move", // 视角移动控件
        ],
        autorotateDelay: 3000, // 初始化延迟时间后旋转
        autorotateIdle: 5000, // 操作后空闲时间后旋转
        autorotateSpeed: 0.1, // 转动速度
        moveInertia: true, // 是否开启惯性
      })
      this.viewer.on("ready", () => {
        // 修改手势
        const el = this.$refs.panoramaContainer;
        const canvas = el.querySelector('canvas') || el.querySelector('img') || el;
        if (canvas) {
          canvas.style.cursor = 'grab';
          canvas.addEventListener('mousedown', () => canvas.style.cursor = 'grabbing');
          document.addEventListener('mouseup', () => canvas.style.cursor = 'grab');
        }
      })
    },
  }
};
</script>

<style scoped>
.viewer {
  width: 100%;
  height: 80vh;
  background: #000;
}
</style>
